import { Alert } from '@mui/material'
import { any, func } from 'prop-types'
import styled from 'styled-components'

export const Status = props => {
  return <StyledAlert {...props} />
}

export const GridStatus = ({ value, getColor, getLabel }) => {
  const label = (getLabel && getLabel(value)) || value
  if (!value) return null
  return (
    <GridStatusWrap>
      <Status severity={getColor && getColor(value)}>{label}</Status>
    </GridStatusWrap>
  )
}

GridStatus.propTypes = {
  value: any,
  getColor: func,
  getLabel: func,
}

Status.propTypes = Alert.propTypes

const StyledAlert = styled(Alert)`
  display: inline-block !important;
  padding: 0 0.5rem !important;
  border-radius: 12px !important;
  font-size: 0.75rem !important;

  .MuiAlert-message {
    padding: 4px 0 !important;
  }
`
StyledAlert.defaultProps = {
  icon: false,
}

const GridStatusWrap = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`
